import { render, staticRenderFns } from "./CommonMalady.vue?vue&type=template&id=3fa81ac6&scoped=true&"
import script from "./CommonMalady.vue?vue&type=script&lang=js&"
export * from "./CommonMalady.vue?vue&type=script&lang=js&"
import style0 from "./CommonMalady.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CommonMalady.vue?vue&type=style&index=1&id=3fa81ac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa81ac6",
  null
  
)

export default component.exports